/* eslint-disable no-nested-ternary */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';

import { XX } from 'Constants/images';

import css from './VasTag.APP_TARGET.scss';
import { BLACKBACKGROUND2, MONETIZATIONDARK1 } from 'Constants/colors';

export const VasTag = ({
    vasConfigVal,
    itemId,
    onTrack,
    setVasItem,
    gradient,
    onVasTagTap
}) => {
    const handleTap = useCallback(() => {
        setVasItem({
            selectedItemId: itemId
        });

        onTrack('vas_tag_clicked', {
            select_from: 'adpv',
            chosen_option: vasConfigVal.title,
            item_id: itemId
        });

        onVasTagTap();
    }, [itemId, onVasTagTap, setVasItem, onTrack, vasConfigVal.title]);

    function showText(label, minChar) {
        return label ? (label.length > minChar ? `${label.substring(0, minChar)}...` : label) : '';
    }

    const titleMinLength = 22;
    const subTitleMinLength = 36;

    return (
        <div className={ classNames(css.tag, css[gradient]) } onClick={ handleTap } >
            <div className={ css.tagImg } >
                <ImageWrapper
                    fileName={ vasConfigVal.imageURI || '' }
                    fileSize={ XX }
                />
            </div>
            <div className={ css.tagText }>
                <p className={ css.tagTitle }>{ showText(vasConfigVal.title, titleMinLength) }<span className={ css.textCross }>{ vasConfigVal.price }</span></p>
                <p className={ css.description }>{ showText(vasConfigVal.subtitle, subTitleMinLength) }</p>
            </div>
        </div>
    );
};

VasTag.defaultProps = {
    onTrack: () => {}
};

VasTag.propTypes = {
    itemId: PropTypes.string.isRequired,
    vasConfigVal: PropTypes.object.isRequired,
    setVasItem: PropTypes.func.isRequired,
    onTrack: PropTypes.func.isRequired,
    onVasTagTap: PropTypes.func.isRequired,
    gradient: PropTypes.oneOf([BLACKBACKGROUND2, MONETIZATIONDARK1])
};

export default React.memo(VasTag);
